import { gql } from "@apollo/client";

export const CMSPagesQuery = gql`
  query CMSPages($locale: String) {
    pages(locale: $locale)
  }
`;

export const CMSPageByRouteQuery = gql`
  query CMSPageByRoute($route: String!, $locale: String) {
    pageByRoute(route: $route, locale: $locale)
  }
`;

export const CMSPageByIdQuery = gql`
  query CMSPageById($id: String!, $locale: String) {
    pageByID(id: $id, locale: $locale, populate: 1)
  }
`;

export const PageLinksQuery = gql`
  query PageLinks($pageId: String!, $locale: String) {
    pageLinks(pageId: $pageId, locale: $locale) {
      parent
      _id
      type
      children
      title
      slug
      route
    }
  }
`;
